import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SharedModule } from '../shared/shared.module';

import { ProfilePage } from './profile.page';
import { NgxSmartModalModule } from 'ngx-smart-modal';


import { DateTimeIntl } from 'src/app/shared/classes/dateTimeIntl';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';

import { QRCodeModule } from 'angularx-qrcode';

const routes: Routes = [
  {
    path: '',
    component: ProfilePage
  }
];

@NgModule({
  imports: [
    SharedModule,
    NgxSmartModalModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    QRCodeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ProfilePage],
  providers: [DatePipe]
})
export class ProfilePageModule { }
